import styled from '@emotion/styled/macro'

export const UserInputDropdownContentSubText = styled.p`
  -o-text-overflow: ellipsis;
  border: 0;
  color: rgba(0,0,0,0.3);
  font: inherit;
  font-size: 0.8em;
  margin: 0;
  overflow: hidden;
  padding: 0;
  text-overflow: ellipsis;
  vertical-align: baseline;
  white-space: nowrap;
`

export const UserInputDropdownContentAvatar = styled.div`
  left: 0.5em;
  position: absolute;
  top: 0.5em;
  width: 2.4em;
`

export const UserInputDropdownContentMainText = styled.p`
  -o-text-overflow: ellipsis;
  border: 0;
  font-size: 100%;
  margin: 0 0 0.3em;
  overflow: hidden;
  padding: 0;
  text-overflow: ellipsis;
  vertical-align: baseline;
  white-space: nowrap;
`

export const UserInputDropdownContentTextWrapper = styled.div`
  color: #232934;
  display: block;
  min-height: 4.4em;
  padding: 0.2em 0.4em 0.6em 4.4em;
  position: relative;
  text-align: left;

  &:hover {
    background-color: #f1f3f4;
    cursor: pointer;
  }
`
